export default __webpack_public_path__ + "static/media/foodprices.95edc63d.jpg";